module.exports = __webpack_public_path__ + "static/bgless3_0731.bb669d4e.png";